import { Script, graphql, useStaticQuery } from "gatsby";

interface SEOProps {
  title: string | null | undefined;
  description: string | null | undefined;
  pathname: string;
  creator?: string;
  image?: string;
}

export default function Seo({
  title,
  description,
  pathname,
  creator = "",
  image,
}: SEOProps) {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    siteUrl,
  } = useSiteMetadata() ?? {};

  const seo = {
    title: title ?? defaultTitle,
    description: description ?? defaultDescription,
    image: image ?? defaultImage,
    url: `${siteUrl ?? ""}${pathname}`,
    creator,
  };

  return (
    <>
      {/* basic head elements */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description ?? ""} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, minimal-ui"
      />

      {/* twitter seo */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={seo.creator} />
      <meta name="twitter:title" content={seo.title ?? ""} />
      <meta name="twitter:description" content={seo.description ?? ""} />
      <meta name="twitter:image" content={seo.image ?? ""} />

      {/* og seo */}
      <meta property="og:title" content={seo.title ?? ""} />
      <meta property="og:description" content={seo.description ?? ""} />
      <meta
        property="og:image"
        content={seo.image ?? "https://www.meetcampfire.com/defaultOGImage.jpg"}
      />
      <meta
        property="og:image:secure_url"
        content={seo.image ?? "https://www.meetcampfire.com/defaultOGImage.jpg"}
      />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />

      {/* Hubspot */}
      <Script type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js" />
      <Script>
        {`
          !function(){var e=["identify","page","startAutoPage","stopAutoPage","startAutoIdentify","stopAutoIdentify"];function t(o){return Object.assign([],e.reduce(function(r,n){return r[n]=function(){return o.push([n,[].slice.call(arguments)]),o},r},{}))}window.unify||(window.unify=t(window.unify)),window.unifyBrowser||(window.unifyBrowser=t(window.unifyBrowser));var n=document.createElement("script");n.async=!0,n.setAttribute("src","https://tag.unifyintent.com/v1/LgU6DoxGHmJxL9UJ8CFTeU/script.js"),n.setAttribute("data-api-key","wk_XkXYRLdz_48mGqGBnBGRvQB1fguxtCCb2Z1Mg8nyL"),n.setAttribute("id","unifytag"),(document.body||document.head).appendChild(n)}();
        `}
      </Script>
      <Script>
        {`
          !function(e,o){let t=0,n=!1;e.__default__={form_id:176757,team_id:506},function e(){const c=o.createElement("script");c.async=!0,c.src="https://import-cdn.default.com/v2/index.js",c.onload=()=>{n=!0,console.info("[Default.com] Powered by Default.com")},c.onerror=()=>{++t<=3&&(setTimeout(e,1e3*t),Z)},o.head.appendChild(c)}()}(window,document);
        `}
      </Script>
    </>
  );
}

export const useSiteMetadata = () => {
  const data: Queries.SeoQuery = useStaticQuery(graphql`
    query Seo {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
        }
      }
    }
  `);

  return data.site?.siteMetadata;
};
